







































































































import CreateAccount from "../components/CreateAccount.vue";
import EditAccount from "../components/EditAccount.vue";
import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import { Account } from "../models/Account";
import axios from "axios";
import fileDownload from "js-file-download";
import { Token } from "../utils/Token";
import { Error } from "../utils/Error";

@Component({
  components: {
    CreateAccount,
    EditAccount,
  },
  filters: {
    transformAccountStatus(value: number) {
      return value == 100 ? "Active" : "Disabled";
    },
    transformclientStatus(value: boolean) {
      return value ? "Ready" : "Pending";
    },
  },
})
export default class AccountListing extends Vue {
  private search = "";
  private createAccountModalFlag = false;
  private editAccountModalFlag = false;
  private usage = "";

  private users: Array<Account> = [];

  private headers = [
    {
      text: "First Name",
      align: "start",
      value: "firstName",
      sortable: true,
    },
    {
      text: "Last Name",
      value: "lastName",
      sortable: true,
      align: "start",
    },
    {
      text: "Extension",
      value: "extension",
      sortable: true,
      align: "start",
    },
    {
      text: "Status VPN",
      value: "statusVpn",
      sortable: true,
      align: "center",
    },
    {
      text: "Status SIP",
      value: "statusSip",
      sortable: true,
      align: "center",
    },
    {
      text: "Client VPN Status",
      value: "clientStatus",
      sortable: true,
      align: "center",
    },
    {
      text: "Client SIP Status",
      value: "linphoneStatus",
      sortable: true,
      align: "center",
    },
    {
      text: "Account Status",
      value: "accountStatus",
      sortable: true,
      align: "center",
    },
    { 
      text: "Actions", 
    value: "actions", 
    sortable: false, 
    align: "center" 
    },
  ];

  //  don't allow entrance to app if no token exists
  /* beforeCreate() {
    const token = localStorage.getItem("token");

    if (!token) {
      this.$router.push({ name: "Login" });
    }
  } */

  async downloadApk(extension: number, filename: string) {
    const token = await Token.getTokenWithExpiry("token");
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      responseType: "blob",
      withCredentials: true,
      url: `${process.env.VUE_APP_APK_URL}/${extension}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          fileDownload(response.data, filename);
        }
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        Error.handleError(err);
      });
  }

  async downloadLinphone(extension: number, filename: string) {
    const token = await Token.getTokenWithExpiry("token");
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      responseType: "blob",
      withCredentials: true,
      url: `${process.env.VUE_APP_SIP_URL}/${extension}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          fileDownload(response.data, filename);
        }
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );
        Error.handleError(err);
      });
  }

  created() {
    this.fetchUsers();
    EventBus.$off('closeCreateAccountModal')
    EventBus.$off('closeEditAccountModal')
    EventBus.$off('refreshListing')
    EventBus.$off('refreshUsage')
    EventBus.$off('refreshAccounts')

    // socket connection end //
    EventBus.$on("closeCreateAccountModal", (value: boolean) => {
      this.createAccountModalFlag = value;
    });

    EventBus.$on("closeEditAccountModal", (value: boolean) => {
      this.editAccountModalFlag = value;
    });

    EventBus.$on("refreshListing", () => {
      this.fetchUsers();
    });

    //when usage socket receives message, emits to this event to refresh usage
    EventBus.$on("refreshUsage", (value: string ,conf:any) => {
      this.usage = value;
    });

    //when accounts socket receives message, emits to this event to refresh users table
    EventBus.$on("refreshAccounts", (value: Array<Account>) => {
      this.users = value;
    });
  }



  private async fetchUsers() {
    console.log("Fetching Users");

    const token = await Token.getTokenWithExpiry("token");
    console.log("token:", token);
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/accounts`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );
        if (response.data.code == 200) {
          console.log("response:", response);
          this.users = [];

          response.data.results.forEach((user: Account) => {
            user = new Account(
              user.firstName,
              user.lastName,
              user.extension,
              user.statusVpn,
              user.statusSip,
              user.clientStatus,
              user.linphoneStatus,
              user.accountStatus,
              user.accountId,
              user.description,
              user.realAddress,
              user.bytesSent,
              user.connectedSince,
              user.ipv4Address,
              user.netMask,
              user.gateway,
              "",
              "",
              0,
            );

            this.users.push(user);
          });
        } else {
          console.log("logout event");
          EventBus.$emit("LogOutEventBus", false);
          Error.handleError(response);
        }
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );
        Error.handleError(err);
      });
  }

  private showCreateAccountModal() {
    this.createAccountModalFlag = true;
  }

  private editUser(user: object) {
    EventBus.$emit("openEditAccountModal", user);
    this.editAccountModalFlag = true;
  }
}
